module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-700italic.woff?e961bdb476db6860f20ff571a84a55b0";